function normalizeAssetPath(assetPath: string): string {
  return assetPath.replace(/^\/+/, '');
}

function normalizeBaseUrl(baseUrl: string): string {
  return baseUrl.replace(/\/+$/, '');
}

function getStaticAssetDeploymentVersion(): string | null {
  const value = process.env.PUBLIC_ASSET_DEPLOYMENT_VERSION?.trim();
  return value && value.length > 0 ? value : null;
}

export function usesVersionedStaticAssets(): boolean {
  return Boolean(getStaticAssetDeploymentVersion());
}

export function getVersionedPublicAssetUrl(assetPath: string, fallbackOrigin?: string): string {
  const normalizedAssetPath = normalizeAssetPath(assetPath);
  const staticAssetDeploymentVersion = getStaticAssetDeploymentVersion();

  if (staticAssetDeploymentVersion) {
    const relativePath = `/assets/${staticAssetDeploymentVersion}/${normalizedAssetPath}`;
    if (!fallbackOrigin) {
      return relativePath;
    }

    return `${normalizeBaseUrl(fallbackOrigin)}${relativePath}`;
  }

  const relativePath = `/${normalizedAssetPath}`;
  if (!fallbackOrigin) {
    return relativePath;
  }

  return `${normalizeBaseUrl(fallbackOrigin)}${relativePath}`;
}
